import { render, staticRenderFns } from "./ExternalFormTemplate.vue?vue&type=template&id=4d161f30&lang=pug"
import script from "./ExternalFormTemplate.vue?vue&type=script&lang=js"
export * from "./ExternalFormTemplate.vue?vue&type=script&lang=js"
import style0 from "./ExternalFormTemplate.vue?vue&type=style&index=0&id=4d161f30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports